<template>
  <div id="copyWrapper">
    <p 
      id="copyResponse"
      role="alert"
      v-if="copyMsg != ''"
      :class="copySuccess ? 'success' : 'error'"> 
        <font-awesome-icon v-if="copySuccess" icon="check" />
        {{ copyMsg }}

    </p>
    <button id="copyLink" @click="copyLink" >Copy Link
        <font-awesome-icon :icon="['far', 'copy']" />
    </button>
  </div>
</template>
<script setup>
import {ref} from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const copyMsg = ref('')
const copySuccess = ref(false)

/**
 * Copy map URL to clipboard. If app, copu path and append with production url
 * 
 * @returns {void}
 */
function copyLink() {
  //If app, set URL to production path and append "#/map?[url-query]"
  //Otherwise web so use whatever is in the URL bar.
  const url = process.env.VUE_APP_MODE === 'hybrid' ? 'https://www.gla.ac.uk/apps/uofglife/#'+route.fullPath : window.location.href

  navigator.clipboard.writeText(url)
    .then(() => {
      //Show the user it was successful somehow
      copySuccess.value = true
      copyMsg.value = 'Link copied successfully.'

      setTimeout(() => {
        copyMsg.value = ''
      }, "3000");
    })
    .catch(() => {
      copySuccess.value = false
      copyMsg.value = 'Unable to copy link'

      setTimeout(() => {
        copyMsg.value = ''
      }, "3000");
    })
}
</script>
<style>

#copyWrapper {
    display: flex;
    align-items: stretch;
    align-self: flex-end;
}

#copyLink {
    border: none;
    height: 44px;
    background-color: #fff;
    color: var(--uog-dark-blue);
    align-self:flex-end;
    padding: 0px 1rem;
    transition: all 0.4s;
}

#copyLink:hover {
    background-color: var(--uog-dark-blue);
    color:#fff;
}

#copyLink:active {
    background-color: var(--uog-blue-10);
    color: var(--uog-dark-blue); 
}

#copyResponse {
    margin-bottom: 0px;
}

#copyResponse {
  display: flex;
  align-items: center;
  padding: 0px 1rem;
}


#copyResponse.success {
  background-color: #D4EDDA;
  color: #155724;
}

#copyResponse.error {
  background-color: #f8d7da;
  color: #721c24;
}

#copyResponse svg {
    margin-right: 0.5rem;
}
</style>
